import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Coordinate plot — Y axis on the left, X axis on the bottom, plus a
 *  smooth curve that rises and falls (a single hump), capped with a
 *  small filled dot to hint at a sampled data point. Reads as
 *  "function plot" / "data graph" at any size 14px+. */
export function IcnGraph(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="graph">
      {/* Y axis with arrowhead */}
      <path d="M3 14 V2.5" />
      <path d="M2 3.5 L3 2.5 L4 3.5" />
      {/* X axis with arrowhead */}
      <path d="M3 13 H14" />
      <path d="M13 12 L14 13 L13 14" />
      {/* Curve — rises to a peak around x=7, descends, gentle tail up */}
      <path d="M3.5 12 Q5.5 5 8 8 T13.5 5" />
      {/* Sampled point */}
      <circle cx="8" cy="8" r="1" fill="currentColor" stroke="none" />
    </Svg>
  );
}
